module.exports = __webpack_public_path__ + "img/jieti.74874e2b.svg";